export default function IosGameControllerBOutline() {
  return (
    <div
      className="ion-icon-ios-game-controller-b-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M308.076,203.929c-11.058,0-20.076,9.014-20.076,20.104c0,11.089,9.019,20.107,20.076,20.107
			c11.131,0,20.148-9.019,20.148-20.107C328.225,212.942,319.207,203.929,308.076,203.929z"/>
		<path d="M351.988,247.878c-11.058,0-20.053,8.949-20.053,20.106c0,11.064,8.995,20.016,20.053,20.016
			c11.146,0,20.148-8.951,20.148-20.016C372.137,256.827,363.134,247.878,351.988,247.878z"/>
		<path d="M135.234,184.367C113.594,184.367,96,202.17,96,224.01c0,21.865,17.594,39.623,39.234,39.623
			c21.655,0,39.249-17.758,39.249-39.623C174.483,202.17,156.89,184.367,135.234,184.367z M135.123,243.457
			c-10.688,0-19.343-8.721-19.343-19.447c0-10.725,8.655-19.441,19.343-19.441c10.641,0,19.297,8.717,19.297,19.441
			C154.42,234.736,145.764,243.457,135.123,243.457z"/>
		<path d="M351.988,160c-11.058,0-20.053,9.014-20.053,20.107c0,11.09,8.995,20.083,20.053,20.083
			c11.146,0,20.148-8.993,20.148-20.083C372.137,169.014,363.134,160,351.988,160z"/>
		<path d="M395.947,203.929c-11.105,0-20.101,9.014-20.101,20.104c0,11.089,8.995,20.107,20.101,20.107
			c11.059,0,20.053-9.019,20.053-20.107C416,212.942,407.006,203.929,395.947,203.929z"/>
	</g>
	<path d="M466.279,248.866c-21.157-88.471-43.631-135.489-88.454-148.83C368.06,97.135,359.748,96,352.076,96
		c-27.598,0-46.938,14.683-96.08,14.683c-49.174,0-68.502-14.681-96.062-14.683c-7.665,0-15.963,1.135-25.721,4.036
		c-44.869,13.341-67.342,60.359-88.461,148.83c-21.181,88.473-17.334,152.363,7.679,164.289C57.502,415.1,61.662,416,65.885,416
		c21.694,0,45.139-23.838,67.659-52.047C159.198,331.848,165.658,331,243.822,331h24.343c78.147,0,84.628,0.846,110.282,32.953
		c22.526,28.207,45.97,52.004,67.665,52.004c4.226,0,8.384-0.879,12.457-2.823C483.574,401.208,487.421,337.339,466.279,248.866z
		 M451.677,398.716c-1.835,0.876-3.604,1.284-5.564,1.284c-6.022,0-14.077-4.049-23.295-11.708
		c-9.181-7.63-19.307-18.509-31.87-34.239c-12.959-16.22-23.667-28.229-43.528-33.949c-16.647-4.793-38.624-5.104-79.254-5.104
		h-24.343c-40.633,0-62.611,0.311-79.259,5.105c-19.853,5.719-30.56,17.685-43.523,33.908
		c-12.556,15.727-22.68,26.627-31.862,34.258c-9.216,7.658-17.27,11.718-23.293,11.718c-1.932,0-3.751-0.415-5.568-1.282
		c-9.556-4.557-22.572-47.673,0.998-146.129c21.387-89.591,42.381-126.777,77.459-137.207c7.633-2.27,14.554-3.372,21.159-3.372
		c9.742,0,18.599,2.317,29.812,5.249c16.07,4.203,36.072,9.435,66.252,9.435c30.148,0,50.146-5.228,66.215-9.429
		c11.229-2.936,20.1-5.254,29.865-5.254c6.618,0,13.551,1.104,21.185,3.371c35.037,10.428,56.03,47.617,77.456,137.214
		C474.244,351.041,461.23,394.16,451.677,398.716z"/>
</g>
</svg>
`,
      }}
    />
  )
}
